import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'loyaltic-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
   @Input() showNavigation = true;

  constructor() { }

  ngOnInit() {
  }

}
